module.exports = __webpack_public_path__ + "static/media/momentumSOLAR@2x.d3edbd6e.png";